export { default } from "./partnerInfo";
